import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Create the Integration URL`}</h2>
    <h3>{`In CP4AIOPS:`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to `}<inlineCode parentName="p">{`Data and tool connections`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under `}<inlineCode parentName="p">{`Slack`}</inlineCode>{` click on `}<inlineCode parentName="p">{`1 integration`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy out the URL`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack004.png",
          "alt": "secure_gw_search"
        }}></img>
      </li>
    </ol>
    <p>{`This is the URL you will be using for step 6.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      